<template>
  <div class="app">
    <DefaultHeader id="pgiHeader" :totalNotif="notifCount" :list="list" @did-tap-notification="didTapNotification" @did-logout="didLogout" />
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>

        <div class="sidebar-user">
          <div class="sidebar-user-data">
            <div class="sidebar-user-icon">
              <i class="fa fa-user"></i>
            </div>
            <div class="sidebar-user-info">
                <span class="sidebar-user-name">{{dashboardName}}</span>
                <span class="sidebar-user-position">{{dashboardRole}}</span>
            </div>
            <div class="sidebar-user-actions">
                <span class="header-user-setting" v-b-tooltip.hover title="Ubah Password" @click="$bvModal.show('modal-change-password')">
                    <i class="fa fa-cog"></i>
                </span>
                <span class="header-user-setting" v-b-tooltip.hover title="Log Out" @click="$bvModal.show('modal-confirm-logout')">
                    <i class="fa fa-power-off"></i>
                </span>
            </div>
          </div>
          <div class="sidebar-user-cabang">
            <CabangOption />
          </div>
        </div>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <!-- <SidebarMinimizer/> -->
      </AppSidebar>
      <main class="main ">
        <div class="container-fluid">
          <router-view @changeSidebarNav="changeSidebarNav" ></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <!-- <DefaultAside/> -->
      </AppAside>
    </div>
    <DefaultFooter id="pgiFooter" />
  </div>
</template>

<script>
import nav from '@/_nav'
import { Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside } from '@coreui/vue'
// import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultHeader from './DefaultHeader'
import DefaultFooter from './DefaultFooter'
import CabangOption from '../components/cabang/CabangOption'

export default {
    name: 'DefaultContainer',
    components: {
        AppSidebar,
        AppAside,
        // DefaultAside,
        DefaultHeaderDropdownAccnt,
        SidebarForm,
        SidebarFooter,
        SidebarHeader,
        SidebarNav,
        SidebarMinimizer,
        DefaultFooter,
        DefaultHeader,
        CabangOption
    },
    data () {
        return {
			nav: [],
            dashboardName: localStorage.getItem("name"),
            dashboardRole: localStorage.getItem("role"),
            dashboardCabang: localStorage.getItem("activeCabang"),
            
            // hasNotification: false,
            notifCount: 0,
            sse: null,
            os: null,
            firebase: null

        }
    },
    computed: {
        name () {
            return this.$route.name
        },
        list () {
            return this.$route.matched.filter((route) => (route.name || route.meta.label) && !route.meta.hideInBreadcrumb)
        }
    },
    methods: {

        changeSidebarNav(){
            let menuTop = localStorage.getItem("menuTop")
			let arrayMenuTop = menuTop ? menuTop.split(",") : []

			let copyNav = JSON.parse(JSON.stringify(nav.items))

            let menu = copyNav.filter(item => arrayMenuTop.includes(item.code))

			menu.forEach(this.checkChildren)

            this.nav = menu
        },

		validateNavItem(){
			let menuTop = localStorage.getItem("menuTop")
			let arrayMenuTop = menuTop ? menuTop.split(",") : []

			let copyNav = JSON.parse(JSON.stringify(nav.items))

            let menu = copyNav.filter(item => arrayMenuTop.includes(item.code))

            menu.forEach(this.checkChildren)
            
            let menuFix = menu.filter((item,index=0)=>{
                if(item.code == 'EKS' && (localStorage.getItem('isauthorized') == 'false')){
                    let newAksesLapeks = {
                        name: 'Akses Laporan Eksekutif',
                        url: '/akses-laporan-eksekutif',
                        icon: 'fa fa-square',
                        code: 'ALE',
                    }
                    menu.splice(index, 1);
                    console.log(index)
                    menu.push(newAksesLapeks)
                }
                index++
            })

            this.nav = menu
		},

		checkChildren(item){
			let menuChildren = localStorage.getItem("menuChildren")
			let arrayMenuChildren = menuChildren ? menuChildren.split(",") : []
			if(item.children != undefined){
				item.children = item.children.filter(child => arrayMenuChildren.includes(child.code))
				if(item.children.length > 0){
					item.redirect = item.children[0].url
				} else {
					delete item.children
				}
			}
		},

        didLogout() {

            if(this.firebase != null && this.firebase.messaging.isSupported()) {

                // Invalidate token
                let fcmToken = localStorage.getItem("fcmToken")
                if(fcmToken != null) {

                    let payload = new FormData()
                    payload.append("token", fcmToken)
                    this.$axios.post("/user/logout", payload)
                    this.firebase.messaging().deleteToken(fcmToken)

                }

            }

            // Clears localstorage
            this.$axios.defaults.headers.common['Authorization'] = ""
            var version = localStorage.getItem("version")
            localStorage.clear()
            localStorage.setItem("version", version)

            this.$router.push("/login")

        },

        didTapNotification() {
            this.notifCount = 0
        }

    },
    created() {

		this.validateNavItem()

        // Auto-redirect to login page if token does not exist --> moved to router
        // if(localStorage.getItem("token") == null) {
        //     this.$router.push({ path: "/login" })
        // }

        let that = this

        /// ==== SETUP FIREBASE MESSAGING
        let firebase = this.$firebase
        this.firebase = firebase

        if(firebase.messaging.isSupported()) {

            let messaging = firebase.messaging()

            messaging.requestPermission().then(() => {

                console.log('Notification permission granted.');
            
                // Get Token
                messaging.getToken().then((token) => {
                    
                    // console.log("FCM Token received: " + token)
                    localStorage.setItem("fcmToken", token)

                    let payload = new FormData()
                    payload.append("token", token)
                    that.$axios.post("/user/fcm-token", payload).then(res => {

                        // new Notification("Selamat datang!", {
                        //     body: "Anda terhubung dengan jaringan notifikasi PGI!"
                        // })

                    })

                })

            }).catch((err) => {
                console.log('Unable to get permission to notify.', err);
            });

            messaging.onMessage((payload) => {

                new Notification(payload.notification.title, {
                    icon: payload.notification.icon,
                    body: payload.notification.body
                })
                console.log('Message received. ', payload);
                that.notifCount++

            })  

            messaging.onTokenRefresh(() => {

                messaging.getToken().then((refreshedToken) => {

                    console.log('Token refreshed.')

                    // Invalidate last token
                    let lastToken = localStorage.getItem("fcmToken")

                    if(lastToken != null) {

                        let payload = new FormData()
                        payload.append("token", lastToken)

                        that.$axios.post("/user/logout", payload)

                    }

                    // Set new token
                    localStorage.setItem("fcmToken", refreshedToken)

                    let payload = new FormData()
                    payload.append("token", refreshedToken)
                    that.$axios.post("/user/fcm-token", payload)

                }).catch((err) => {
                    console.log('Unable to retrieve refreshed token ', err)
                });

            });

        }

    },
    beforeDestroy() {

        if(this.firebase != null && this.firebase.messaging.isSupported()) {

            // Invalidate token
            let fcmToken = localStorage.getItem("fcmToken")
            if(fcmToken != null) {

                let payload = new FormData()
                payload.append("token", fcmToken)
                this.$axios.post("/user/logout", payload)
                this.firebase.messaging().deleteToken(fcmToken)

            }

        }

        this.$axios.defaults.headers.common['Authorization'] = ""
        var version = localStorage.getItem("version")
       // localStorage.clear()
        localStorage.setItem("version", version)

    }
}
</script>
